<template>
  <!-- 图片上传 -->
  <div class="upload">
    <draggable
      :list="list"
      :options="{draggable: '.preview'}"
      class="drag-group"
      @update="onUpdate"
    >
      <template v-if="type === 'image'">
        <div v-for="(item,index) in list" :key="index" @click="select(item)" class="preview">
          <outline :show="item.selected"></outline>
          <img :src="item.src" alt />
        </div>
      </template>

      <template v-if="type === 'video'">
        <div v-for="(item,index) in list" :key="index" @click="select(item)" class="preview">
          <outline :show="item.selected"></outline>
          <video controls>
            <source :src="item.src" type="video/mp4" />
            <source :src="item.src" type="video/ogg" />您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </template>

      <div v-show="selecteds.length<limit" slot="footer" class="add-image">
        <i class="el-icon-plus" />
        <div class="hover-box">
          <template v-if="isUpload">
            <el-button size="mini" type="file" ref="file">上传{{typeCn}}</el-button>
            <p>—— 或 ——</p>
          </template>
          <template v-if="isCatch">
            <el-button size="mini" @click="dialogCaptureVisible = true">选择抓取{{typeCn}}</el-button>
            <p>—— 或 ——</p>
          </template>
          <el-button size="mini" @click="dialogLinkVisible = true">填写{{typeCn}}链接</el-button>
        </div>
      </div>
    </draggable>

    <!-- dialog - 选择抓取图片 -->
    <dialog-capture
      :type="type"
      :visible.sync="dialogCaptureVisible"
      :selecteds="selecteds"
      @change="dialogCaptureChange"
      :optionalPic="optionalPic"
      :modal="childModal"
    />

    <!-- dialog - 填写图片链接 -->
    <dialog-link
      :type="type"
      :visible.sync="dialogLinkVisible"
      :selecteds="selecteds"
      @change="dialogLinkChange"
      :modal="childModal"
    />
  </div>
</template>

<script>
import { getToken } from '@/utils/auth'; // getToken from cookie
import draggable from 'vuedraggable';
import dialogCapture from './components/dialogCapture';
import dialogLink from './components/dialogLink';
import outline from './components/outline';
import plupload from 'plupload';
import createUniqueString from '@/utils/createUniqueString';
import { API_URL } from '@/utils/request';

export default {
  components: {
    draggable, // 拖拽
    dialogCapture, // 选择抓取图片
    dialogLink, // 填写图片链接
    outline,
  },

  props: {
    //上传数量(废弃)
    uploadLimit: {
      type: Number,
      default: 99,
    },
    type: {
      // 类型: image / video
      type: String,
      default: 'image',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selecteds: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 1,
    },
    optionalPic: {
      type: Array,
      default: () => [],
    },
    isCatch: {
      // 是否采集
      type: Boolean,
      default: true,
    },
    isUpload: {
      // 是否上传图片
      type: Boolean,
      default: true,
    },

    // 蒙版
    childModal: {
      type: Boolean,
      default: true,
    },
  },

  data: () => ({
    list: [],
    dialogLinkVisible: false, // 可见 - 选择抓取图片
    dialogCaptureVisible: false, // 可见 - 填写图片链接
  }),

  computed: {
    typeCn() {
      return this.type === 'image' ? '图片' : '视频';
    },
  },

  watch: {
    selecteds: {
      immediate: true,
      deep: true,
      handler() {
        // this.$nextTick(() => {
        //   this.initUploader();
        // });
        this.upPic();
      },
    },
  },

  mounted() {
    this.initUploader();
  },

  methods: {
    // 获取图片
    upPic() {
      this.list = this.selecteds;
    },

    // 添加图片
    add(links) {
      // 超出限制
      console.log('选中', this.selecteds.length);

      links.forEach((v, k) => {
        if (this.limit - this.selecteds.length - k - 1 < 0) {
          v.selected = false;
        }
      });
      this.list = this.list.concat(links);
      this.filter();
    },

    onUpdate() {},

    // 选择图片
    select(item) {
      if (item.selected) {
        item.selected = false;
      } else {
        // 如果只有一张则直接切换
        if (this.limit == 1) {
          this.list.map((arr) => {
            arr.selected = false;
          });
          item.selected = true;
          return;
        }
        // 超出最大可选
        if (this.selecteds.length >= this.limit) {
          this.$message({
            type: 'error',
            message: `你最多可以选${this.limit}张`,
          });
          return;
        }
        item.selected = true;
      }
      this.filter();
    },

    // 过滤选中
    filter() {
      var selecteds = this.list.filter((v) => {
        return v.selected == true;
      });
      // selecteds = selecteds.map(v => {
      //   return v.src
      // })
      this.$emit('update:selecteds', selecteds);
    },

    // 上传图片
    initUploader() {
      try {
        if (!this.$refs.file || !this.$refs.file.$el) return;
        const that = this;
        var uploader = new plupload.Uploader({
          browse_button: that.$refs.file.$el, //触发文件选择对话框的按钮，为那个元素id
          url: `${API_URL}?do=picture_add`, //服务器端的上传页面地址
          file_data_name: 'picture',
          multipart_params: {
            sid: getToken(),
            type: 'taobaoke',
          },
          filters: {
            max_file_size: '10240kb',
          },
          resize: {
            quality: 60,
            preserve_headers: false,
          },
          max_retries: 2,
        });
        uploader.init();

        uploader.bind('FilesAdded', (uploader) => {
          uploader.start();
        });
        uploader.bind('FileUploaded', (uploader, file, responseObject) => {
          let data = JSON.parse(responseObject.response);
          if (data.error_code == 0) {
            this.uploader(data.file);
          } else {
            this.$message.error(data.error_message);
          }
        });
        uploader.bind('Error', (uploader, errObject) => {
          this.$message.error(errObject.message);
        });
      } catch (e) {
        console.log(e);
      }
    },

    // 选择抓取图片
    dialogCaptureChange(links) {
      this.add(links);
    },

    // 填写图片链接
    dialogLinkChange(links) {
      this.add(links);
    },

    // 上传图片
    uploader(filePath) {
      this.add([
        {
          src: filePath,
          id: createUniqueString(),
          selected: true,
        },
      ]);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  margin-right: -16px;
  margin-bottom: -16px;
}

.drag-group {
  display: flex;
  flex-wrap: wrap;
  // 预览图
  .preview {
    position: relative;
    display: inline-block;
    width: 148px;
    height: 148px;
    line-height: 148px;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 2px;
    overflow: hidden;
    text-align: center;
    img {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
    video {
      max-width: 100%;
      max-height: 100%;
      vertical-align: middle;
    }
  }
  // 上传 or 选择
  .add-image {
    width: 148px;
    height: 148px;
    border: 1px dashed $theme-textplaceholder;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 2px;
    overflow: hidden;
    font-size: 12px;
    position: relative;
    display: inline-block;

    &:hover {
      .hover-box {
        opacity: 1;
        pointer-events: all;
        z-index: 0;
      }
      i {
        opacity: 0;
        pointer-events: none;
        z-index: -1;
      }
    }

    p {
      margin: 0;
      transform: scale(0.83);
      height: 14px;
      line-height: 14px;
      color: $theme-textplaceholder;
    }

    i {
      font-size: 28px;
      color: $theme-textplaceholder;
      position: relative;
      z-index: 0;
      opacity: 1;
      transition: all 0.3s ease;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .hover-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      opacity: 0;
      pointer-events: none;
      z-index: -1;
      position: relative;
      transition: all 0.3s ease;
    }
    .el-button {
      position: relative;
      overflow: hidden;
    }
    .el-button input {
      position: absolute;
      font-size: 50px;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      min-width: 100%;
      min-height: 100%;
      opacity: 0;
      overflow: hidden;
    }
  }
}
</style>